import { guards } from './typeguards.helpers';

/**
 * Safely converts unknown errors to Error instances
 * Preserves specific Error types when input is already an Error
 */
export function toError<T extends Error>(error: T): T;
export function toError(unknownError: unknown): Error;
export function toError(unknownError: unknown): Error {
  if (unknownError instanceof Error) return unknownError;

  // If error is a string, create a new Error with that string
  if (guards.is.string(unknownError)) return new Error(unknownError);

  // If error is a plain object with a message property, create a new Error with that message
  if (guards.is.object(unknownError) && 'message' in unknownError) {
    return new Error(String(unknownError.message));
  }

  return new Error(`Unknown error [${String(unknownError)}]`);
}
